import * as React from 'react';
import { cn } from '@common/bw-ui/lib/utils';
import { ChevronLeftIcon } from '@common/bw-ui/icons';

export interface BackLinkProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
}

const BackLink = React.forwardRef<HTMLButtonElement, BackLinkProps>(
  ({ children = 'Back', className, ...props }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'tw:inline-flex tw:items-center tw:gap-1 tw:text-sm tw:text-muted tw:hover:text-foreground tw:transition-colors tw:bg-transparent tw:border-none tw:cursor-pointer tw:p-0',
          className,
        )}
        {...props}
      >
        <ChevronLeftIcon
          className="tw:w-4 tw:h-4 tw:shrink-0"
          aria-hidden="true"
        />
        {children}
      </button>
    );
  },
);
BackLink.displayName = 'BackLink';

export { BackLink };
